import {
  AmountType,
  BaseBotData,
  BasicBotData,
  BotData,
  BotType,
  DisplayResultMessage,
  MainCoinAmountData,
  MainCoinsAvailableAmountsData,
} from "@shared/types";
import { ReactNode } from "react";
import { PercentageBaseType } from "@shared/features/bots/BotForm/common/types";

export enum MyBotsSort {
  NAME = "my_bots_sort.name",
  TOTAL_PROFIT = "my_bots_sort.closed_trades_profit",
  CLOSED_TRADES = "my_bots_sort.number_of_closed_trades",
  OPEN_TRADES = "my_bots_sort.number_of_open_trades",
  REALIZED_PNL = "my_bots_sort.realized_pnl",
  TAKE_PROFITS_FILLED = "my_bots_sort.take_profits_filled",
  LAST_ENTRY = "my_bots_sort.last_entry_filled",
  NEXT_TAKE_PROFIT = "my_bots_sort.take_profit_distance",
  NEXT_ENTRY_OR_STOP = "my_bots_sort.next_entry_or_stop_distance",
  SYMBOL = "my_bots_sort.symbol",
  GROUP = "my_bots_sort.group",
  CREATED = "my_bots_sort.created_date",
  AMOUNT = "my_bots_sort.amount",
  LAST_TRADE_OPENED = "my_bots_sort.last_trade_opened",
}

export enum BotsTab {
  MY_BOTS = "my-bots",
  PUBLIC_BOTS = "public-bots",
}

export enum MobileBotsTab {
  MY_BOTS = "myBots",
  BACKTESTING = "backtesting",
  PUBLIC = "public",
  SIGNALS = "signals",
  TV_TO_SIGNALS = "tvToSignals",
}

export interface AmountData {
  mainCoin: number;
  BTCAmount: number;
  USDAmount: number;
}

export interface BotAmountEffectiveTotalBreakdown {
  availableAmount: AmountData;
  openTradesAmount: AmountData;
  totalAmount: AmountData;
  selectedAmount: AmountData;
  percentage: number;
}

export interface BotAmountData extends MainCoinsAvailableAmountsData {
  convertMainCoinAmountToAmountType: (
    amount: number,
    applyPrecision?: boolean,
    amountType?: AmountType
  ) => number | undefined;
  mainCoinAmount: number;
  showAmountWarning?: boolean;
  availableAmount: AmountData;
  effectiveTotalBreakdown?: BotAmountEffectiveTotalBreakdown;
  getSelectedAmount?: (
    amountData?: MainCoinAmountData,
    amountType?: AmountType,
    amountValue?: number
  ) => number;
  initialized: boolean;
  amountType?: AmountType;
  amountValue?: number;
  amountPercentageBaseType?: PercentageBaseType;
  amountCustomBaseValue?: number;
}

export enum PublicBotSummaryTabs {
  SUMMARY = "Summary",
  STATISTICS = "Statistics",
}

export enum BulkUpdateBotStep {
  CLOSE_TRADES = 1,
  CONFIRM_INACTIVE_ACCOUNT = 2,
  CONFIRM = 3,
}

export interface UseSharedBulkUpdateBotsModalProps {
  open?: boolean;
  botsIDs?: number[];
  closeModal: () => void;
  isDeactivate?: boolean;
  onFinish?: () => void;
  displayResultMessage: DisplayResultMessage;
  botType: BotType;
  botIDToBotData: Record<number, BotData | BasicBotData>;
}

export type BulkUpdateBotsModalProps = Omit<
  UseSharedBulkUpdateBotsModalProps,
  "displayResultMessage"
>;

export interface BulkDeleteBotsModalProps {
  isOpen?: boolean;
  closeModal: () => void;
  onOk?: () => void;
  content?: ReactNode;
  isLoading?: boolean;
}

export interface BotConfigurationModalProps {
  bot?: BaseBotData;
  closeModal: () => void;
  open?: boolean;
  isFetching?: boolean;
  isBulkEdit?: boolean;
  showAmount?: boolean;
  title?: string;
  isChannelConfiguration?: boolean;
}

export enum BotExtraDetailsTabs {
  GENERAL = "general",
  TIMELINE = "active-trade",
}

export enum SignalsBotSummaryTab {
  MOST_TRADED_PAIR = "signals_bot_summary_tabs.most_traded_pair",
  BACKTESTING_HISTORY = "signals_bot_summary_tabs.backtesting_history",
}

export type SubGroupSignalFrequencyResponse = {
  last_signal_open_time: number;
  signals_frequency: number;
};

export enum BacktestingExtraDetailsTabs {
  GENERAL = "general",
  TRADES = "trades",
  CONFIGURATION = "configuration",
}
